import { useEffect, useState, useCallback } from "react";
import { Button, Modal } from "react-bootstrap";

const ModalHoraExtra = (props) => {
  const {
    estado,
    onCloseModal,
    item,
    onReturnValue,
  } = props;

  // Estados originales
  const [horaextra, setHoraExtra] = useState(item.HoraExtra); // "True" | "False"
  const [IDLEGAJO, setIdLegajo] = useState(item.IdLegajoEnfermeria);
  const [EstaConfirmado, setEstaConfirmado] = useState(
    Array.isArray(item.estaConfirmado?.data)
      ? item.estaConfirmado.data[0]
      : item.estaConfirmado
  );
  const [Formdata3, setValue] = useState(item);

  // Asegurar número para toFixed
  const inicialDecimal = Number(item.horaextramaximo) || 0;
  const initialHours = Math.floor(inicialDecimal);
  const initialMinutes = Math.round((inicialDecimal - initialHours) * 60);

  // Estados separados para horas y minutos (como texto para controlar input)
  const [hoursStr, setHoursStr] = useState(initialHours.toString().padStart(2, "0"));
  const [minutesStr, setMinutesStr] = useState(initialMinutes.toString().padStart(2, "0"));

  // Valor decimal final (máximo 2 decimales)
  const [horashoraextra, setHorasHoraExtra] = useState(Number(inicialDecimal.toFixed(2)));

  // Validaciones
  const [errors, setErrors] = useState({
    hours: "",
    minutes: "",
    general: "",
  });

  const sanitizeInteger = (value) => {
    const cleaned = value.replace(/\D+/g, "");
    return cleaned;
  };

  const handleHoursChange = (e) => {
    const v = sanitizeInteger(e.target.value);
    setHoursStr(v);
  };

  const handleMinutesChange = (e) => {
    let v = sanitizeInteger(e.target.value);
    if (v.length > 0) {
      let num = parseInt(v, 10);
      if (num > 59) num = 59;
      v = num.toString();
    }
    setMinutesStr(v);
  };

  const computeDecimal = useCallback(() => {
    const h = hoursStr === "" ? 0 : parseInt(hoursStr, 10);
    const m = minutesStr === "" ? 0 : parseInt(minutesStr, 10);
    return Number((h + m / 60).toFixed(2));
  }, [hoursStr, minutesStr]);

  useEffect(() => {
    const hEmpty = hoursStr === "";
    const mEmpty = minutesStr === "";

    const h = hEmpty ? 0 : parseInt(hoursStr, 10);
    const m = mEmpty ? 0 : parseInt(minutesStr, 10);

    const newErrors = { hours: "", minutes: "", general: "" };

    if (hEmpty) newErrors.hours = "Ingrese horas (entero ≥ 0).";
    else if (isNaN(h) || h < 0) newErrors.hours = "Horas debe ser un entero ≥ 0.";

    if (mEmpty) newErrors.minutes = "Ingrese minutos (entero 0–59).";
    else if (isNaN(m) || m < 0 || m > 59) newErrors.minutes = "Minutos debe estar entre 0 y 59.";

    if (horaextra === "True" && (h + m) === 0) {
      newErrors.general = "Si habilita Hora Extra, horas + minutos debe ser mayor que 0.";
    }

    setErrors(newErrors);

    if (!newErrors.hours && !newErrors.minutes) {
      setHorasHoraExtra(Number((h + m / 60).toFixed(2)));
    } else {
      setHorasHoraExtra(null);
    }
  }, [hoursStr, minutesStr, horaextra]);

  const isFormInvalid = () => {
    return (
      !!errors.hours ||
      !!errors.minutes ||
      !!errors.general ||
      horashoraextra === null
    );
  };

  const handleSubmit2 = (event) => {
    event.preventDefault();

    if (isFormInvalid()) {
      return;
    }

    const formdata = { horaextra, horashoraextra: Number(horashoraextra.toFixed(2)), IDLEGAJO, EstaConfirmado };
    onReturnValue(formdata, Formdata3);
  };

  return (
    <Modal show={estado} onHide={onCloseModal}>
      <Modal.Header closeButton>
        <Modal.Title>Hora Extra</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <form onSubmit={handleSubmit2} id="auFORM">
          <div className="form-group mb-3">
            <label className="col-form-label w-100">
              Habilitar Hora Extra? <span className="text-danger">*</span>
            </label>
            <select
              className="form-control"
              onChange={(e) => setHoraExtra(e.target.value)}
              value={horaextra}
            >
              <option value="True">Si</option>
              <option value="False">No</option>
            </select>
          </div>

            <div className="form-group mb-3">
              <label className="col-form-label w-100">
                Cantidad de Hora Extra <span className="text-danger">*</span>
              </label>
              <div className="text-muted mb-2">
                Ingrese horas y minutos (solo enteros). Minutos entre 0 y 59.
              </div>
              <div className="d-flex gap-2">
                <div style={{ flex: 1 }}>
                  <label className="form-label">Horas</label>
                  <input
                    type="text"
                    inputMode="numeric"
                    className={`form-control ${errors.hours ? "is-invalid" : ""}`}
                    value={hoursStr}
                    onChange={handleHoursChange}
                    placeholder="0"
                  />
                  {errors.hours && (
                    <div className="invalid-feedback">{errors.hours}</div>
                  )}
                </div>
                <div style={{ width: "120px" }}>
                  <label className="form-label">Minutos</label>
                  <input
                    type="text"
                    inputMode="numeric"
                    className={`form-control ${errors.minutes ? "is-invalid" : ""}`}
                    value={minutesStr}
                    onChange={handleMinutesChange}
                    placeholder="0"
                  />
                  {errors.minutes && (
                    <div className="invalid-feedback">{errors.minutes}</div>
                  )}
                </div>
              </div>
              {errors.general && (
                <div className="text-danger mt-2">{errors.general}</div>
              )}
              {horashoraextra !== null && (
                <div className="mt-2 small text-primary">
                  Valor decimal: {horashoraextra.toFixed(2)} h
                </div>
              )}
            </div>
        </form>
      </Modal.Body>
      <Modal.Footer>
        <Button variant="danger" onClick={onCloseModal}>
          Cerrar
        </Button>
        <Button
          type="submit"
          form="auFORM"
          disabled={isFormInvalid()}
        >
          Guardar
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default ModalHoraExtra;